import React from 'react';
import { STRINGS } from '../utils/constants';

// In RTL the visual "previous" arrow points right and "next" points left.
const PeriodNavigator = ({
  label,
  onPrevious,
  onNext,
  onToday,
  canGoNext,
  isAtCurrentPeriod,
  disabled = false,
}) => {
  if (!label) return null;

  return (
    <div className="period-nav" role="group" aria-label={STRINGS.currentPeriod}>
      <button
        type="button"
        className="period-nav__arrow"
        onClick={onPrevious}
        disabled={disabled}
        title={STRINGS.previous}
        aria-label={STRINGS.previous}
      >
        <i className="fa fa-chevron-right" aria-hidden="true" />
      </button>

      <div className="period-nav__label">
        <i className="fa fa-calendar-o" aria-hidden="true" />
        <span>{label}</span>
      </div>

      <button
        type="button"
        className="period-nav__arrow"
        onClick={onNext}
        disabled={disabled || !canGoNext}
        title={STRINGS.next}
        aria-label={STRINGS.next}
      >
        <i className="fa fa-chevron-left" aria-hidden="true" />
      </button>

      <button
        type="button"
        className="period-nav__today"
        onClick={onToday}
        disabled={disabled || isAtCurrentPeriod}
        title={STRINGS.today}
      >
        <i className="fa fa-dot-circle-o" aria-hidden="true" /> {STRINGS.today}
      </button>
    </div>
  );
};

export default PeriodNavigator;
